import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthRestaurantService, AuthUserService } from '@tablesready/frontend-store';

import { combineLatest, filter, map, pairwise, switchMap, tap } from 'rxjs';
import { PermissionService } from '@tablesready/frontend-permissions';

@Injectable()
export class PermissionCheckerService {
  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly authRestaurantService: AuthRestaurantService,
    private readonly permissionService: PermissionService,
    private readonly userService: AuthUserService,
  ) {
  }

  listenChanges() {
    return combineLatest([
      this.authRestaurantService.select()
        .pipe(
          pairwise(),
          filter(([prev, current]) => prev === null
            || prev.location?._id !== current.location?._id
            || prev.locationUser?.scope !== current.locationUser?.scope
            || prev.accountUser?.role !== current.accountUser?.role
          ),
          map(([, current]) => current),
        ),
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        switchMap(() => {
          let route = this.route;
          while (route.firstChild) {
            route = route.firstChild;
          }

          return route.data;
        })
      ),
    ])
      .pipe(
        map(([user, {scopes, availableFor}]) => {
          if (scopes && availableFor) {
            return this.permissionService.userAccountHasScopes(user, scopes, availableFor);
          }

          return true;
        }),
        tap(result => {
          if (!result) {
            const redirectUrl = this.router.url === '/waitlist'
              ? '/profile/details'
              : '/waitlist';
            this.router.navigate([redirectUrl]);
          }
        }),
      );
  }

  // Redirects user to profile if email or name is empty
  isProfileFilled() {
    return combineLatest([
      this.userService.select().pipe(map(user => !!(user.email && user.name))),
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.router.url),
      ),
    ])
      .pipe(
        tap(([isProfileFilled, navigatedUrl]) => {
          if (!isProfileFilled && navigatedUrl !== '/profile/details') {
             void this.router.navigateByUrl('/profile/details');
          }
        }),
      );
  }
}
